import React, { ChangeEvent, DragEvent, useState } from 'react';

import { Box, Grid, lighten, Typography, useTheme } from '@mui/material';

import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type FileUploadProps = {
    accept: string;
    width?: string;
    height?: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onDrop: (event: DragEvent<HTMLElement>) => void;
};

export const FileUpload: React.FunctionComponent<FileUploadProps> = function ({
    accept,
    width = '100%',
    height = '200px',
    onChange,
    onDrop,
}) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isHover, setIsHover] = useState<boolean>(false);

    const stopDefaults = (e: DragEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event);
    };

    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);

    const handleDrop = (event: DragEvent<HTMLElement>) => {
        stopDefaults(event);
        onDrop(event);
    };

    const dragEvents = {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onDragEnter: (e: DragEvent) => {
            stopDefaults(e);
        },
        onDragLeave: (e: DragEvent) => {
            stopDefaults(e);
        },
        onDragOver: stopDefaults,
        onDrop: (e: DragEvent<HTMLElement>) => {
            handleDrop(e);
        },
    };

    const { palette } = useTheme();

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
            >
                <Box
                    component="label"
                    htmlFor="file-upload"
                    width={width}
                    height={height}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 3,
                        borderStyle: 'dashed',
                        borderColor: lighten(palette.primary.main, 0.3),
                        borderRadius: '30px',
                        cursor: 'pointer',
                    }}
                    {...dragEvents}
                >
                    <input
                        id="file-upload"
                        type="file"
                        onChange={handleChange}
                        accept={accept}
                        multiple
                        style={{ display: 'none', width: '100%' }}
                    />
                    <Box sx={{ marginLeft: '-20px' }}>
                        <FaOptionIcon
                            icon="cloud-arrow-up"
                            color={palette.grey[500]}
                            size="2xl"
                            sx={{ width: '100%' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Typography
                            variant="caption"
                            color={palette.grey[500]}
                        >
                            Glisser ou cliquer pour importer un fichier
                        </Typography>
                        <Typography
                            variant="caption"
                            color={palette.grey[500]}
                        >
                            ({accept})
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
